import request from './axios'

/**
 * 获取所属分类
 * @returns {*}
 */

export function queryCertificateFeedback() {
  return request({
    url: `/lx/certificateClassification/filterTree`,
    method: 'get'
  })
}

export function queryCertificateClassification(type) {
  return request({
    // url: `/lx/certificateClassification/filterTree`,
    url: `/lx/certificateClassification/categories?type=${type}`,
    method: 'get'
  })
}

/**
 * 根据分类id获取热词
 * @param id  分类id
 * @returns {*}
 */
export function queryHotWords(id) {
  return request({
    url: `/lx/hotSearch/getHotById/${id}`,
    method: 'get'
  })
}

/**
 * 获取证书列表
 * @param data  查询条件
 * @returns {*}
 */
export function queryCertificatesList(data) {
  return request({
    url: `/lx/certificate/list`,
    method: 'post',
    data
  })
}

/**
 * 添加收藏（含备注）
 * @param id  证书id
 * @param data  备注信息
 * @returns {AxiosPromise}
 */
export function addCollection(id, data) {
  return request({
    url: `/lx/certificate/like/${id}`,
    method: 'post',
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    },
    data
  })
}

/**
 * 取消收藏
 * @param id  证书id
 * @returns {*}
 */
export function cancelCollection(id) {
  return request({
    url: `/lx/certificate/notLike/${id}`,
    method: 'post'
  })
}

/**
 * 下载证书
 * @param id  证书id
 * @returns {*}
 */
export function downLoadCertificates(id) {
  return request({
    url: `/lx/certificate/downLoad/${id}`,
    method: 'post',
    responseType: 'blob',
  })
}

/**
 * 添加反馈
 * @param data
 * @returns {AxiosPromise}
 */
export function addFeedback(data) {
  return request({
    url: `/lx/certificateFeedback/addFeedback`,
    method: 'post',
    data
  })
}

/**
 * 查看证书
 * @param id
 * @returns {AxiosPromise}
 */
export function queryViewCertificateLink(id) {
  return request({
    url: `/lx/certificate/detail/${id}`,
    method: 'get',
  })
}

/**
 * 根据证书id检查证书是否过期
 * @param id
 * @returns {AxiosPromise}
 */
export function checkReminderById(id) {
  return request({
    url: `/lx/certificate/checkReminderById?id=${id}`,
    method: 'get',
  })
}

// 查询关联证书
export function getAssociation(number) {
  return request(({
    url: `/lx/certificateAssociation/getAssociation/${number}`,
    method: 'post'
  }))
}
// 型报证书和普通证书判断
export function JudgingCertificates() {
  return request({
    url: `/lx/certificate/isCertificateVisible`,
    method: 'get'
  })
}
